var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-dialog',{staticClass:"breakword",attrs:{"header":_vm.dialogDocHeader},model:{value:(_vm.$_show),callback:function ($$v) {_vm.$_show=$$v},expression:"$_show"}},[_c('div',[_vm._v("Документ не имеет файла")])])}
var staticRenderFns = []

export { render, staticRenderFns }